// src/components/SpaceList.js
import React, { useContext } from 'react';
import { BookingContext } from '../context/BookingContext';

const spaces = [
    "Soccer Field (4 Aside)", 
    // "Tennis Court", 
    // "Gym", 
    // "Snooker Room"
];

const SpaceList = () => {
  const { selectedSpace, setSelectedSpace } = useContext(BookingContext);

  return (
    <div>
      <h2 className="text-xl font-semibold text-gray-700 mb-4">Select a Space</h2>
      <div className="grid grid-cols-2 gap-4">
        {spaces.map((space) => (
          <button
            key={space}
            onClick={() => setSelectedSpace(space)}
            className={`p-2 rounded-lg font-medium text-white ${
              selectedSpace === space ? 'bg-blue-500' : 'bg-gray-400'
            } hover:bg-blue-400 transition-all duration-200`}
          >
            {space}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SpaceList;
